import { createContext, useContext } from 'react'

import { IActionRepeaterValue } from '@makyoapp/makyo-common'

export type ActionTriggerSource = 'menu-item' | 'list' | 'component' | string

interface IActionFormContextV2 {
  editedForm: IActionRepeaterValue | null
  setEditedForm: (form: IActionRepeaterValue | null) => void
  openActionForm: (action: IActionRepeaterValue, triggerSource?: ActionTriggerSource) => void
  closeActForm: () => void
  actionTriggerSource: ActionTriggerSource | null
  actionFormShowClearValue: boolean
  setActionFormShowClearValue: (value: boolean) => void
}

/**
 * ActionFormContext will handle the processing of each action dropdown,
 * if the action requires additional settings, it will show the form and return the `settings` data
 */
export const ActionFormContextV2 = createContext<IActionFormContextV2>({
  editedForm: null,
  setEditedForm: () => {},
  openActionForm: () => {},
  closeActForm: () => {},
  actionTriggerSource: null,
  actionFormShowClearValue: false,
  setActionFormShowClearValue: () => {},
})

const useActionFormContextV2 = () => {
  const context = useContext(ActionFormContextV2)
  if (!context) {
    throw new Error('useActionFormContextV2 must be used within an ActionFormProviderV2')
  }
  return context
}

export { useActionFormContextV2 }
